export function ContentSkeleton() {
  return (
    <div className="space-y-6 p-4">
      {/* header */}
      <div className="rounded-b2b relative h-[162px] animate-pulse bg-gray-100">
        <div className="absolute inset-0 flex">
          <div className="w-full h-full flex flex-col justify-start pt-8 px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div>
                  <div className="flex items-center gap-3">
                    {/* Title skeleton */}
                    <div className="h-7 w-32 bg-primary/20 rounded" />
                  </div>

                  {/* Subtitle skeleton */}
                  <div className="h-4 w-48 bg-primary/20 rounded mt-1" />
                </div>
              </div>

              {/* Switch skeleton */}
              <div className="flex items-center gap-2">
                <div className="w-9 h-5 rounded-full bg-primary/20" />
                <div className="h-7 w-20 bg-white/20 rounded-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Content skeletons */}
      <div className="grid gap-6">
        {/* Card-like skeletons */}
        <div className="h-32 bg-gray-100 rounded-lg animate-pulse" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="h-40 bg-gray-100 rounded-lg animate-pulse" />
          <div className="h-40 bg-gray-100 rounded-lg animate-pulse" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {[1, 2, 3].map((item) => (
            <div
              key={item}
              className="h-24 bg-gray-100 rounded-lg animate-pulse"
            />
          ))}
        </div>

        {/* Table-like skeleton */}
        <div className="space-y-4">
          <div className="h-12 bg-gray-100 rounded animate-pulse" />
          {[1, 2, 3, 4].map((item) => (
            <div
              key={item}
              className="h-16 bg-gray-100 rounded animate-pulse"
            />
          ))}
        </div>
      </div>
    </div>
  )
}

// Skeleton para o layout completo (usado no Suspense principal)
export function LayoutSkeleton() {
  return (
    <main className="bg-white flex h-screen overflow-hidden p-2">
      {/* Sidebar skeleton */}
      <div className="h-full w-64 shrink-0">
        <div className="h-full rounded-lg bg-gray-100 animate-pulse">
          <div className="h-16 border-b border-gray-200 px-4 py-3">
            <div className="h-8 w-32 bg-gray-200 rounded" />
          </div>
          <div className="px-4 py-4 space-y-4">
            {[1, 2, 3, 4, 5].map((item) => (
              <div key={item} className="h-10 bg-gray-200 rounded w-full" />
            ))}
          </div>
        </div>
      </div>

      {/* Content area skeleton */}
      <div className="w-full pb-20 mx-2 overflow-y-auto">
        <ContentSkeleton />
      </div>
    </main>
  )
}
